//@ts-nocheck

'use client'

import React, { useCallback, useEffect, useRef } from 'react'
import Image from 'next/image'

import gsap from 'gsap'

import useEventListener from '../../../hooks/useEventListener'

import { Paragraph } from '../../atoms/Typography/Typography.component'
import { SpacerBase } from '../../atoms/GridSystem'
import LinkWrapper from '../../atoms/LinkWrapper/LinkWrapper.component'
import Icon from '../../atoms/Icon/Icon.component'

import * as S from './CardExpertise.styles'

const CardExpertise = ({ title, imageShape, href, image, colorScheme }) => {

  const cardRef = useRef(null)
  const imageRef = useRef(null)

  const moveHandler = useCallback((ev) => {
    const elem = cardRef.current.getBoundingClientRect()
    
    const depth = 20
    const x = ((ev.clientX - elem.left) / 2) / depth
    const y = ((ev.clientY - elem.top) / 2) / depth
    
    gsap.to(imageRef.current, { x, y })
  }, [])

  useEffect(() => {
    cardRef.current.addEventListener('mousemove', moveHandler)

    return () => {
      if (cardRef.current) {
        cardRef.current.removeEventListener('mousemove', moveHandler)
      }
    }
  }, [])

  return (
    <LinkWrapper href={`${href}`}>
      <S.CardExpertise href={`${href}`} colorScheme={ colorScheme } ref={cardRef}>
        <S.CardExpertiseText colorScheme={colorScheme}>
          <Paragraph typo="headingSM" content={title} weight="medium" colorScheme={colorScheme} />
        </S.CardExpertiseText>
        <S.CardExpertiseImage maskType={imageShape} ref={(el) => imageRef.current = el?.childNodes ? el.childNodes[0] : null}>
          { image ? <Image src={image.url} alt={image.alt} fill sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 75vw" /> : null}
        </S.CardExpertiseImage>
        <S.CardExpertiseIcon>
          <Icon name="arrow-up-right" size="huge" />
        </S.CardExpertiseIcon>
      </S.CardExpertise>
    </LinkWrapper>
  )
}

export default CardExpertise
